import { createFieldOption } from '@/explore/components/select-options/field';

import { Fields, SimpleVisualisation } from '../../../types';
import { SearchInput } from '../../../../components/form/search-input';
import { isNumericField, setVisualisationValueKeys } from '../utils';

interface SimpleVisualisationOptionsFormProps {
  visualisation: SimpleVisualisation;
  onChange: (visualisation: SimpleVisualisation) => void;
  fields: Fields;
}

export const SimpleVisualisationOptionsForm = (props: SimpleVisualisationOptionsFormProps) => {
  const { visualisation, onChange, fields } = props;

  return (
    <>
      {visualisation.valueKeys.map((valueKey, idx) => (
        <SearchInput
          key={idx}
          options={fields.filter(isNumericField).map(createFieldOption)}
          value={valueKey}
          onChange={(value) => {
            const valueKeys = visualisation.valueKeys.map((v, i) => (i === idx ? value : v));
            onChange(setVisualisationValueKeys(visualisation, valueKeys));
          }}
          fullWidth={false}
        />
      ))}
      by
      <SearchInput
        options={fields.map(createFieldOption)}
        value={visualisation.mainAxisKey}
        onChange={(value) => {
          onChange({
            ...visualisation,
            mainAxisKey: value,
          });
        }}
        fullWidth={false}
      />
    </>
  );
};
